import cookie from '@/utils/cookie';
import { APP_INFO_KEY, QUERY_APP_ID, APP_ID_KEY } from '../const';

export function getQueryVariable(variable) {
    const query = window.location.search.substring(1);
    const vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split('=');
        if (pair[0] === variable) {
            return pair[1];
        }
    }
    return false;
}

export function getAppId() {
    const appInfo = JSON.parse(localStorage.getItem(APP_INFO_KEY)) || {};
    return getQueryVariable(QUERY_APP_ID) || appInfo.id || cookie.get(APP_ID_KEY) || '';
}
